document.addEventListener('DOMContentLoaded', function () {
  var forms = document.querySelectorAll('[data-klaviyo-newsletter]');

  forms.forEach(function (form) {
    var message = form.querySelector('.newsletter-signup__message');
    var emailInput = form.querySelector('input[type="email"]');
    var submitButton = form.querySelector('button[type="submit"]');

    function setMessage(text, isError) {
      if (!message) return;
      message.textContent = text;
      message.classList.toggle('is-error', !!isError);
      message.classList.toggle('is-success', !isError);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var email = emailInput ? emailInput.value.trim() : '';
      var publicKey = form.getAttribute('data-public-key');
      var listId = form.getAttribute('data-list-id');

      if (!email) {
        setMessage('Please enter a valid email address.', true);
        return;
      }

      if (!publicKey || !listId) {
        setMessage('Signup is not configured yet.', true);
        return;
      }

      if (submitButton) {
        submitButton.setAttribute('aria-busy', 'true');
        submitButton.disabled = true;
      }

      setMessage('', false);

      var payload = new URLSearchParams();
      payload.append('a', publicKey);
      payload.append('g', listId);
      payload.append('email', email);
      payload.append('$source', window.location.href);
      payload.append('$fields', '$source,$referrer,$title,$path');
      payload.append('$list_fields', '$source,$referrer,$title,$path');
      payload.append('$referrer', document.referrer || '');
      payload.append('$title', document.title || '');
      payload.append('$path', window.location.pathname || '');

      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: payload.toString()
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data && data.success) {
            setMessage('Thank you. Please check your email.', false);
            if (form) form.reset();
            if (window._learnq && typeof window._learnq.push === 'function') {
              window._learnq.push(['identify', { $email: email }]);
              window._learnq.push([
                'track',
                'Newsletter Signup',
                {
                  list_id: listId,
                  source: window.location.href,
                  referrer: document.referrer || '',
                  title: document.title || '',
                  path: window.location.pathname || ''
                }
              ]);
            }
            return;
          }

          var errorMessage = 'Something went wrong. Please try again.';
          if (data && data.errors && data.errors.length) {
            errorMessage = data.errors[0];
          }

          setMessage(errorMessage, true);
        })
        .catch(function () {
          setMessage('Something went wrong. Please try again.', true);
        })
        .finally(function () {
          if (submitButton) {
            submitButton.removeAttribute('aria-busy');
            submitButton.disabled = false;
          }
        });
    });
  });
});